import { Outlet } from 'react-router-dom'
//import '@assets/css/common/style_main.css'
import Header from './Header'
import Sidebar from './Sidebar'
import Footer from './Footer'

function AdminLayout() {
    return (
        <div className="dashboard-container">
            {/* 사이드바 컨테이너 */}
            <div id="sidebar-container">
                <Sidebar />
            </div>

            {/* 헤더 컨테이너 */}
            <div id="header-container">
                <Header />
            </div>

            {/* 메인 콘텐츠 시작 */}
            <div className="content-wrapper fade-transition">
                <Outlet />
            </div>
            <Footer />
        </div>
    );
}

export default AdminLayout